module.exports = __webpack_public_path__ + "img/profile.2bb2a225.png";